// src/pages/SupportRouting.jsx
// Gestión de reglas de ruteo para Atención a Clientes Presico (admin/leader).
// Rediseño 2026-05-13. Lógica 1:1.
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../services/api';


const Icon = ({ children, size = 16, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    flask:  <Icon size={14}><path d="M9 3h6v6.7l4.4 7.6A2 2 0 0 1 17.7 21H6.3a2 2 0 0 1-1.7-3.7L9 9.7z" /><path d="M9 3v6.7" /><path d="M15 3v6.7" /></Icon>,
    plus:   <Icon size={14}><path d="M12 5v14" /><path d="M5 12h14" /></Icon>,
    check:  <Icon size={12}><path d="M20 6 9 17l-5-5" /></Icon>,
    x:      <Icon size={12}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></Icon>,
    edit:   <Icon size={12}><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></Icon>,
    trash:  <Icon size={12}><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></Icon>,
};


const MARCAS = ['*', 'Presico','LA CASITA','LA GUERITA','LA LUPITA','La Moderna','PISTIYO','PRESTAMOS UNIDOS','RAPI VALE','VIVA VALE','Vale Amigo'];
const PAISES = ['*', 'MEXICO','GUATEMALA','EL SALVADOR','HONDURAS','NICARAGUA','COLOMBIA','PERU'];

const newDraft = () => ({
    marca: 'Presico', pais: 'MEXICO',
    localidad: '', ruta: '',
    department: '', description: '', enabled: true,
});


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
.sp-root {
    --sp-accent: var(--brand-700, #0a4aa8);
    --sp-accent-hover: var(--brand-800, #07357f);
    --sp-accent-light: #dbeafe;
    --sp-accent-ring: rgba(10, 74, 168, .12);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    max-width: 1280px; margin: 0 auto; padding: 24px 20px 60px;
    color: var(--c-text-1);
}
.sp-root * { box-sizing: border-box; }
.sp-title { font-size: 24px; font-weight: 700; margin: 0 0 4px; letter-spacing: -0.01em; }
.sp-subtitle { color: var(--c-text-3); font-size: 13.5px; margin: 0 0 18px; line-height: 1.5; }
.sp-subtitle code { background: var(--c-msg-bg); padding: 1px 6px; border-radius: 4px; font-size: 12px; }

/* Tester */
.sp-tester {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 14px; padding: 16px 18px; margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
}
.sp-tester-head {
    display: flex; align-items: center; gap: 8px; margin-bottom: 12px;
    font-weight: 700; font-size: 14px;
}
.sp-tester-grid {
    display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px; align-items: end;
}
.sp-field { display: flex; flex-direction: column; }
.sp-field label {
    font-size: 11px; font-weight: 600; letter-spacing: 0.3px;
    color: var(--c-text-2); margin-bottom: 4px;
}
.sp-input, .sp-select {
    padding: 7px 11px; font-size: 13px;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-input-bg); color: var(--c-text-1);
    font-family: inherit; outline: none;
    transition: border-color .15s, box-shadow .15s;
    width: 100%;
}
.sp-input:focus, .sp-select:focus { border-color: var(--sp-accent); box-shadow: 0 0 0 3px var(--sp-accent-ring); }
.sp-input.sm, .sp-select.sm { padding: 5px 9px; font-size: 12.5px; border-radius: 6px; }

.sp-tester-result {
    margin-top: 12px; padding: 10px 12px;
    background: var(--c-msg-bg); border-radius: 8px;
    font-size: 13px;
    display: flex; align-items: center; gap: 8px;
}
.sp-tester-result strong { color: var(--sp-accent); }
.sp-tester-result-meta { color: var(--c-text-4); font-size: 11px; margin-left: 6px; }

/* Buttons */
.sp-btn {
    display: inline-flex; align-items: center; justify-content: center; gap: 6px;
    border: 1px solid transparent; border-radius: 8px;
    padding: 7px 14px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: inherit;
    transition: all .15s; white-space: nowrap;
}
.sp-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.sp-btn.sm { padding: 5px 11px; font-size: 12px; }
.sp-btn-primary { background: var(--sp-accent); color: #fff; border-color: var(--sp-accent); }
.sp-btn-primary:hover:not(:disabled) { background: var(--sp-accent-hover); border-color: var(--sp-accent-hover); }
.sp-btn-success { background: #059669; color: #fff; border-color: #059669; }
.sp-btn-success:hover:not(:disabled) { background: #047857; border-color: #047857; }
.sp-btn-ghost { background: transparent; color: var(--c-text-2); border-color: var(--c-border); }
.sp-btn-ghost:hover:not(:disabled) { background: var(--c-msg-bg); }
.sp-btn-icon { padding: 5px 8px; }

/* Table */
.sp-table-wrap {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 14px; overflow: hidden;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
}
.sp-table {
    width: 100%; border-collapse: collapse;
    font-size: 13px;
}
.sp-table thead th {
    background: var(--c-msg-bg);
    padding: 10px 14px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--c-text-4);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--c-card-header-border);
    white-space: nowrap;
}
.sp-table tbody td {
    padding: 8px 14px;
    border-bottom: 1px solid var(--c-card-header-border);
    vertical-align: middle;
}
.sp-table tbody tr:last-child td { border-bottom: none; }
.sp-table tbody tr.new-row { background: var(--sp-accent-light); }
.sp-table tbody tr.new-row td { padding: 8px; }
.sp-table tbody tr.editing td { padding: 6px 8px; }
.sp-table tbody tr.disabled-row { opacity: 0.5; }
.sp-table tbody tr.empty td {
    padding: 32px; text-align: center; color: var(--c-text-4); font-style: italic;
}

.sp-pill-dept {
    display: inline-block; padding: 2px 9px; border-radius: 6px;
    background: var(--sp-accent); color: #fff;
    font-size: 11px; font-weight: 600; letter-spacing: 0.2px;
}
.sp-wildcard { color: var(--c-text-4); font-style: italic; }
.sp-actions-cell { display: flex; gap: 4px; }
.sp-checkbox {
    width: 16px; height: 16px; accent-color: var(--sp-accent);
    cursor: pointer;
}

@media (max-width: 800px) {
    .sp-table { font-size: 12px; }
    .sp-table thead th, .sp-table tbody td { padding: 6px 8px; }
}
`;


export default function SupportRouting() {
    const [rules,    setRules]    = useState([]);
    const [depts,    setDepts]    = useState([]);
    const [loading,  setLoading]  = useState(true);
    const [creating, setCreating] = useState(false);

    const [draft, setDraft] = useState(newDraft());

    const [testMarca,     setTestMarca]     = useState('Presico');
    const [testPais,      setTestPais]      = useState('MEXICO');
    const [testLocalidad, setTestLocalidad] = useState('');
    const [testRuta,      setTestRuta]      = useState('');
    const [testRes,       setTestRes]       = useState(null);
    const [testing,       setTesting]       = useState(false);

    useEffect(() => {
        Promise.all([
            api.get('/support/routing'),
            api.get('/departments'),
        ]).then(([r, d]) => {
            setRules(r.data || []);
            setDepts(d.data || []);
        }).catch(() => toast.error('No se pudo cargar')).finally(() => setLoading(false));
    }, []);

    const create = async () => {
        if (!draft.department) { toast.warn('Elegí un departamento'); return; }
        setCreating(true);
        try {
            const { data } = await api.post('/support/routing', draft);
            setRules(prev => [data, ...prev]);
            setDraft(newDraft());
            toast.success('Regla creada');
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
        finally { setCreating(false); }
    };

    const updateRule = async (id, patch) => {
        try {
            const { data } = await api.patch(`/support/routing/${id}`, patch);
            setRules(prev => prev.map(r => r._id === id ? data : r));
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
    };

    const removeRule = async (id) => {
        if (!window.confirm('¿Eliminar regla?')) return;
        try {
            await api.delete(`/support/routing/${id}`);
            setRules(prev => prev.filter(r => r._id !== id));
            toast.success('Regla eliminada');
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
    };

    const runTest = async () => {
        setTesting(true);
        try {
            const { data } = await api.post('/support/routing/test', {
                marca: testMarca, pais: testPais,
                localidad: testLocalidad, ruta: testRuta,
            });
            setTestRes(data);
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
        finally { setTesting(false); }
    };

    return (
        <>
            <style>{CSS}</style>
            <div className="sp-root">
                <h1 className="sp-title">Ruteo de Atención a Clientes</h1>
                <p className="sp-subtitle">
                    Define a qué departamento cae una conversación según los datos del cliente. Deja vacío
                    (o <code>*</code>) un campo para que actúe como wildcard. Gana la regla que matchea
                    {' '}<strong>más campos exactos</strong>.
                </p>

                {/* Tester */}
                <div className="sp-tester">
                    <div className="sp-tester-head">
                        {I.flask} Probar resolución
                    </div>
                    <div className="sp-tester-grid">
                        <div className="sp-field">
                            <label>Marca</label>
                            <select className="sp-select" value={testMarca} onChange={e => setTestMarca(e.target.value)}>
                                {MARCAS.filter(m => m !== '*').map(m => <option key={m} value={m}>{m}</option>)}
                            </select>
                        </div>
                        <div className="sp-field">
                            <label>País</label>
                            <select className="sp-select" value={testPais} onChange={e => setTestPais(e.target.value)}>
                                {PAISES.filter(p => p !== '*').map(p => <option key={p} value={p}>{p}</option>)}
                            </select>
                        </div>
                        <div className="sp-field">
                            <label>Localidad</label>
                            <input className="sp-input" placeholder="(opcional)" value={testLocalidad} onChange={e => setTestLocalidad(e.target.value)} />
                        </div>
                        <div className="sp-field">
                            <label>Ruta</label>
                            <input className="sp-input" placeholder="(opcional)" value={testRuta} onChange={e => setTestRuta(e.target.value)} />
                        </div>
                        <div className="sp-field">
                            <label style={{ visibility: 'hidden' }}>Probar</label>
                            <button type="button" className="sp-btn sp-btn-primary" onClick={runTest} disabled={testing}>
                                {testing ? <Spinner size="sm" animation="border" /> : 'Probar'}
                            </button>
                        </div>
                    </div>
                    {testRes && (
                        <div className="sp-tester-result">
                            → <strong>{testRes.departmentName}</strong>
                            <span className="sp-tester-result-meta">({testRes.ruleDescription})</span>
                        </div>
                    )}
                </div>

                {/* Tabla */}
                {loading ? (
                    <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
                ) : (
                    <div className="sp-table-wrap">
                        <table className="sp-table">
                            <thead>
                                <tr>
                                    <th>Marca</th>
                                    <th>País</th>
                                    <th>Localidad</th>
                                    <th>Ruta</th>
                                    <th>Departamento</th>
                                    <th>Descripción</th>
                                    <th style={{ width: 80, textAlign: 'center' }}>Activa</th>
                                    <th style={{ width: 100 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Fila nueva */}
                                <tr className="new-row">
                                    <td>
                                        <select className="sp-select sm" value={draft.marca} onChange={e => setDraft(d => ({ ...d, marca: e.target.value }))}>
                                            {MARCAS.map(m => <option key={m} value={m}>{m === '*' ? '* (todas)' : m}</option>)}
                                        </select>
                                    </td>
                                    <td>
                                        <select className="sp-select sm" value={draft.pais} onChange={e => setDraft(d => ({ ...d, pais: e.target.value }))}>
                                            {PAISES.map(p => <option key={p} value={p}>{p === '*' ? '* (todos)' : p}</option>)}
                                        </select>
                                    </td>
                                    <td>
                                        <input className="sp-input sm" placeholder="(vacío = *)" value={draft.localidad}
                                            onChange={e => setDraft(d => ({ ...d, localidad: e.target.value }))} />
                                    </td>
                                    <td>
                                        <input className="sp-input sm" placeholder="(vacío = *)" value={draft.ruta}
                                            onChange={e => setDraft(d => ({ ...d, ruta: e.target.value }))} />
                                    </td>
                                    <td>
                                        <select className="sp-select sm" value={draft.department} onChange={e => setDraft(d => ({ ...d, department: e.target.value }))}>
                                            <option value="">— Elige —</option>
                                            {depts.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                                        </select>
                                    </td>
                                    <td>
                                        <input className="sp-input sm" placeholder="Opcional" value={draft.description}
                                            onChange={e => setDraft(d => ({ ...d, description: e.target.value }))} />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input type="checkbox" className="sp-checkbox" checked={draft.enabled}
                                            onChange={e => setDraft(d => ({ ...d, enabled: e.target.checked }))} />
                                    </td>
                                    <td>
                                        <button type="button" className="sp-btn sp-btn-success sm" onClick={create} disabled={creating}>
                                            {creating ? <Spinner size="sm" animation="border" /> : <>{I.plus} Añadir</>}
                                        </button>
                                    </td>
                                </tr>

                                {rules.length === 0 ? (
                                    <tr className="empty"><td colSpan={8}>
                                        Sin reglas. Todo cae en el departamento default.
                                    </td></tr>
                                ) : rules.map(r => (
                                    <RuleRow
                                        key={r._id}
                                        rule={r}
                                        depts={depts}
                                        onUpdate={(p) => updateRule(r._id, p)}
                                        onDelete={() => removeRule(r._id)}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
}


function RuleRow({ rule, depts, onUpdate, onDelete }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState({
        marca: rule.marca, pais: rule.pais,
        localidad: rule.localidad || '', ruta: rule.ruta || '',
        department: rule.department?._id || rule.department,
        description: rule.description || '',
    });

    const save = () => { onUpdate(draft); setEditing(false); };
    const wildcardDisplay = (v) => (!v || v === '*') ? <em className="sp-wildcard">—</em> : v;

    if (editing) {
        return (
            <tr className="editing">
                <td>
                    <select className="sp-select sm" value={draft.marca} onChange={e => setDraft(d => ({ ...d, marca: e.target.value }))}>
                        {MARCAS.map(m => <option key={m} value={m}>{m === '*' ? '* (todas)' : m}</option>)}
                    </select>
                </td>
                <td>
                    <select className="sp-select sm" value={draft.pais} onChange={e => setDraft(d => ({ ...d, pais: e.target.value }))}>
                        {PAISES.map(p => <option key={p} value={p}>{p === '*' ? '* (todos)' : p}</option>)}
                    </select>
                </td>
                <td>
                    <input className="sp-input sm" value={draft.localidad} onChange={e => setDraft(d => ({ ...d, localidad: e.target.value }))} />
                </td>
                <td>
                    <input className="sp-input sm" value={draft.ruta} onChange={e => setDraft(d => ({ ...d, ruta: e.target.value }))} />
                </td>
                <td>
                    <select className="sp-select sm" value={draft.department} onChange={e => setDraft(d => ({ ...d, department: e.target.value }))}>
                        {depts.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                    </select>
                </td>
                <td>
                    <input className="sp-input sm" value={draft.description} onChange={e => setDraft(d => ({ ...d, description: e.target.value }))} />
                </td>
                <td></td>
                <td>
                    <div className="sp-actions-cell">
                        <button type="button" className="sp-btn sp-btn-success sm sp-btn-icon" onClick={save} title="Guardar">{I.check}</button>
                        <button type="button" className="sp-btn sp-btn-ghost sm sp-btn-icon" onClick={() => setEditing(false)} title="Cancelar">{I.x}</button>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        <tr className={rule.enabled ? '' : 'disabled-row'}>
            <td>{rule.marca === '*' ? <em className="sp-wildcard">todas</em> : rule.marca}</td>
            <td>{rule.pais === '*' ? <em className="sp-wildcard">todos</em> : rule.pais}</td>
            <td>{wildcardDisplay(rule.localidad)}</td>
            <td>{wildcardDisplay(rule.ruta)}</td>
            <td><span className="sp-pill-dept">{rule.department?.name || '?'}</span></td>
            <td style={{ color: 'var(--c-text-3)', fontSize: 12 }}>
                {rule.description || <em className="sp-wildcard">—</em>}
            </td>
            <td style={{ textAlign: 'center' }}>
                <input type="checkbox" className="sp-checkbox" checked={rule.enabled}
                    onChange={e => onUpdate({ enabled: e.target.checked })} />
            </td>
            <td>
                <div className="sp-actions-cell">
                    <button type="button" className="sp-btn sp-btn-ghost sm sp-btn-icon" onClick={() => setEditing(true)} title="Editar">{I.edit}</button>
                    <button type="button" className="sp-btn sp-btn-ghost sm sp-btn-icon" onClick={onDelete} title="Eliminar" style={{ color: '#dc2626' }}>{I.trash}</button>
                </div>
            </td>
        </tr>
    );
}
